import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import PriceBases from "./priceBases";
import PriceBasis from "./priceBasis";
import { withTranslation } from "react-i18next";

class PriceBasisAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          children: [
            {
              type: "tab",
              name: this.props.t("PriceBases"),
              enableClose: false,
              component: "PriceBases",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handlePriceBasisSelect = (PriceBasis, submitCallbackFunction, isNew) => {
    const { priceBasisId, name } = PriceBasis;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "PriceBasis",
            name: `${name}`,
            id: `${priceBasisId}`,
            config: { priceBasisId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(FlexLayout.Actions.selectTab(priceBasisId));
    }
  };

  handleTabRename = (nodeId, name) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: name })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();
    //const PriceBasisId = node.getId();

    if (componentId === "PriceBases") {
      return (
        <PriceBases
          onClick={this.handlePriceBasisSelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "PriceBasis") {
      const { priceBasisId, submitCallbackFunction, isNew } = node.getConfig();
      return (
        <PriceBasis
          priceBasisId={priceBasisId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />;
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["markets"])(PriceBasisAdmin);
